import config from '@/config'

export default {
  user_status: {
    NEW: "Pengguna baru, tetapi belum disahkan",
    ACTIVE: "Pengguna aktif",
    RESET: "Kata laluan pengguna telah ditetapkan semula",
    ATTEMPT_BLOCK: "Pengguna disekat kerana 3 percubaan log masuk gagal",
    COMPANY_BLOCK: "Pengguna disekat oleh syarikat",
    SUSPEND: "Pengguna digantung"
  },

  login: "Log Masuk ke akaun anda",
  relogin: "Sila log masuk semula ke akaun anda.",
  expired: "Sesi Tamat!",
  denied: "Kebenaran Ditolak!",
  success: "BERJAYA",
  search_by_id: "Cari mengikut ID",
  search_by_full_id: "Cari mengikut ID penuh",
  successful_change_password: "Anda telah berjaya menukar kata laluan.",
  select_option: "Pilih pilihan anda",
  no_data_available: "Tidak Ada Data Tersedia",
  no_rating_available: "Tidak Ada Penilaian Tersedia",
  successful_update_security: "Anda telah berjaya mengemas kini keselamatan.",
  successful_disable_security: "Anda telah berjaya melumpuhkan keselamatan.",
  update_security_confirm: "Adakah anda pasti ingin mengemas kini keselamatan?",
  disable_security_confirm: "Adakah anda pasti ingin melumpuhkan keselamatan?",
  change_operator_status_confirm: "Adakah anda pasti ingin menukar status operator \"{name}\"?",
  change_member_status_confirm: "Adakah anda pasti ingin menukar status ahli \"{name}\"?",
  change_bank_account_status_confirm: "Adakah anda pasti ingin menukar status akaun \"{name}\"?",
  change_promotion_seq_confirm: "Adakah anda pasti ingin menukar urutan \"{id}\"?",
  change_promo_status_confirm: "Adakah anda pasti mahu menukar status promosi \"{name}\"?",
  change_promo_signup_status_confirm: "Adakah anda pasti mahu menukar status pendaftaran promosi \"{name}\"?",
  successful_update_account_setup: "Anda telah berjaya mengemas kini tetapan akaun.",
  unblock_member_confirm: "Adakah anda pasti ingin menyahhalang ahli \"{name}\"?",
  unblock_operator_confirm: "Adakah anda pasti ingin menyahhalang pengendali \"{name}\"?",
  block_sub_account_confirm: "Adakah anda pasti ingin menyekat sub akaun \"{name}\"?",
  unblock_sub_account_confirm: "Adakah anda pasti ingin menyahsekat sub akaun \"{name}\"?",
  successful_create_secondary_account: "Anda telah berjaya mencipta akaun sekunder.",
  successful_update_account_password: "Anda telah berjaya mengemas kini kata laluan akaun.",
  update_account_password_cancel: "Adakah anda pasti ingin membatalkan kemas kini kata laluan akaun?",
  change_affiliate_status_confirm: "Adakah anda pasti ingin menukar status rakan kongsi \"{name}\"?",
  unblock_affiliate_confirm: "Adakah anda pasti ingin menyekat semula rakan kongsi \"{name}\"?",
  change_coupon_status_confirm: "Adakah anda pasti ingin menukar status kupon \"{name}\"?",
  submit_acknowledgement_confirm: "Adakah anda pasti mahu menghantar pengakuan?",
  change_bank_group_default_confirm: "Adakah anda pasti mahu menetapkan \"{name}\" sebagai kumpulan bank lalai?",
  change_withdrawal_limit_default_confirm: "Adakah anda pasti mahu menetapkan \"{name}\" sebagai had pengeluaran lalai?",
  change_promotion_group_default_confirm: "Adakah anda pasti mahu menetapkan \"{name}\" sebagai kumpulan promosi lalai?",
  change_referral_status_confirm: "Adakah anda pasti mahu menukar status rujukan \"{name}\"?",
  change_withdrawal_limit_confirm: "Adakah anda pasti mahu menukar had pengeluaran \"{name}\"?",
  change_promotion_group_confirm: "Adakah anda pasti ingin menukar kumpulan promosi \"{name}\"?",
  change_bank_group_confirm: "Adakah anda pasti ingin menukar kumpulan bank \"{name}\"?",
  change_member_bet_limit_confirm: "Adakah anda pasti ingin menukar had pertaruhan \"{name}\" \"{provider}\"?",
  assign_free_credit_confirm: "Adakah anda pasti mahu memberikan kredit percuma kepada \"{name}\"?",
  update_survey_status_confirm: "Adakah anda pasti mahu mengemas kini status tinjauan?",
  move_banner_up_confirm: "Adakah anda pasti mahu menggerakkan banner \"{name}\" ke atas?",
  move_banner_down_confirm: "Adakah anda pasti mahu menggerakkan banner \"{name}\" ke bawah?",
  delete_banner_confirm: "Adakah anda pasti mahu memadam banner \"{name}\"?",
  change_banner_status_confirm: "Adakah anda pasti mahu menukar status banner \"{name}\"?",
  delete_page_confirm: "Adakah anda pasti mahu memadam halaman \"{name}\"?",
  change_page_status_confirm: "Adakah anda pasti mahu menukar status halaman \"{name}\"?",
  clear_maintenance_time_confirm: "Adakah anda pasti mahu membersihkan masa penyelenggaraan \"{name}\"?",
  successful_clear_outstanding: "Anda telah berjaya membersihkan jumlah tertunggak sebanyak {amt}.",
  clear_outstanding_confirm: "Adakah anda pasti mahu membersihkan tertunggak \"{name}\"?",
  trace_outstanding_confirm: "Adakah anda pasti mahu menjejak tunggakan \"{name}\"?",
  change_setting_confirm: "Adakah anda pasti mahu menukar tetapan \"{name}\"?",
  add_bonus_list_member_confirm: "Adakah anda pasti mahu menambah ahli terpilih ke senarai bonus?",
  delete_bonus_list_member_confirm: "Adakah anda pasti mahu memadam ahli terpilih dari senarai bonus?",
  delete_ip_address_confirm: "Adakah anda pasti mahu memadam ip \"{ip}\" di bawah \"{name}\"?",
  add_ip_address_confirm: "Adakah anda pasti mahu menambah ip \"{ip}\" di bawah \"{name}\"?",
  change_payment_mode_status_confirm: "Adakah anda pasti ingin menukar status mod pembayaran \"{name}\"?",
  change_provider_group_status_confirm: "Adakah anda pasti ingin menukar status \"{group}\" di bawah \"{mode}\"?",
  bulk_issue_bonus_member_confirm: "Adakah anda pasti ingin mengeluarkan bonus kepada ahli dalam senarai bonus?",
  change_provider_group_recommend_confirm: "Adakah anda pasti ingin menukar cadangan \"{group}\" di bawah \"{mode}\"?",
  change_provider_group_seq_confirm: "Adakah anda pasti ingin menukar urutan \"{group}\" di bawah \"{mode}\"?",
  no_member_found: "Tiada Ahli Ditemui",
  redeposit_ticket_confirm: "Adakah anda pasti mahu mendeposit semula tiket?",
  change_provider_group_limit_confirm: "Adakah anda pasti mahu menukar had \"{group}\" di bawah \"{mode}\"?",
  audit_ticket_confirm: "Adakah anda pasti mahu menyemak tiket tersebut?",
  review_ticket_confirm: "Adakah anda pasti mahu menyemak tiket tersebut?",
  change_promotion_group_seq_confirm: "Adakah anda pasti mahu menukar urutan \"{promotion}\" di bawah \"{group}\"?",
  unlock_custom_vip_confirm: "Adakah anda pasti mahu membuka kunci vip khas \"{name}\"?",
  move_affiliate_confirm: "Adakah anda pasti mahu memindahkan keseluruhan cawangan \"{name}\" terus di bawah \"{operator}\"?",
  cancel_unfinish_round_confirm: "Adakah anda pasti mahu membatalkan pusingan yang belum selesai \"{round}\"?",
  change_payment_mode_seq_confirm: "Adakah anda pasti mahu menukar urutan \"{mode}\"?",
  remove_bank_default_provider_confirm: "Adakah anda pasti mahu mengeluarkan penyedia lalai \"{bank}\"?Adakah anda pasti mahu mengalih keluar penyedia lalai \"{bank}\"?",
  change_label_status_confirm: "Adakah anda pasti mahu menukar status label \"{name}\"?",
  clear_iframe_url_confirm: "Adakah anda pasti mahu membersihkan url iframe?",
  delete_turnover_tier_confirm: "Adakah anda pasti mahu memadam tier turnover \"{name}\"?",
  vip_provider_rebate_batch_confirm: "Adakah anda pasti untuk meneruskan kemas kini batch rebat penyedia VIP?",
  copy_rebate_rate_all_confirm: "Adakah anda pasti ingin menyalin \"{name}\" dari \"{provider}\" kepada semua penyedia?",
  edit_vip_confirm: "Adakah anda ingin mengemas kini kadar rebat \"{name}\"?",
  add_promotion_custom_member_confirm: "Adakah anda ingin menambah senarai ahli khusus promosi?",
  delete_promotion_custom_member_confirm: "Adakah anda ingin memadam senarai ahli khusus promosi \"{name}\"?",
  change_rescue_fund_status_confirm: "Adakah anda pasti ingin menukar status dana penyelamatan \"{name}\"?",
  add_rescue_fund_custom_member_confirm: "Adakah anda ingin menambah senarai ahli khusus dana penyelamatan?",
  delete_rescue_fund_custom_member_confirm: "Adakah anda pasti ingin memadam senarai ahli khusus dana penyelamatan \"{name}\"?",
  change_ads_status_confirm: "Adakah anda pasti ingin menukar status iklan \"{name}\"?",
  adjust_amount_bank_tooltip: "Sokong tanda tolak (-) untuk menolak baki dari baki akaun bank",
  adjust_amount_operator_tooltip: "Sokong tanda tolak (-) untuk menolak baki dari dompet operator",
  adjust_amount_member_tooltip: "Sokong tanda tolak (-) untuk menolak baki dari baki ahli",
  purchase_domain_tooltips: "Tahniah!! Semoga impian anda menjadi kenyataan!",
  change_provider_game_seq_confirm: "Adakah anda pasti ingin menukar urutan \"{mode}\"?",
  purchase_domain_confirm: "Adakah anda pasti ingin membeli domain \"{name}\"?",
  search_by_domain_name: "Cari Mengikut Nama Domain",
  search_by_domain_status: "Cari Mengikut Status Domain",
  search_by_account_id: "Cari Mengikut ID Akaun",
  search_by_operator_id: "Cari Mengikut ID Pengendali",
  search_by_full_name: "Cari Mengikut Nama Penuh",
  search_by_contact_phone: "Cari Mengikut Telefon Hubungi",
  search_by_signup_ip: "Cari Mengikut IP Pendaftaran",
  search_by_referral_code: "Cari Mengikut Kod Rujukan",
  search_by_bank_acc_no: "Cari Mengikut No Akaun Bank",
  search_by_affiliate_code: "Cari Mengikut Kod Afiliasi",
  info1: "1. Subdomain tidak dibenarkan",
  info2: "2. Tidak memerlukan 'https://' atau 'http://'",
  info3: "3. Contoh: abc.com",
  move_announcement_banner: "Susun semula banner",
  atLeastOneChecked: "Sekurang-kurangnya satu ambang perlu diperiksa",
  adjustWalletTooltips: "Sokong tanda tolak (-) untuk menolak baki dari dompet rakan kongsi",
  emailOTPTooltips: "OTP melalui email akan tamat dalam 3 minit selepas permintaan",
  domain_status_update_confirm: "Adakah anda ingin mengemas kini status \"{name}\"?",
  delete_access_control_confirm: "Adakah anda pasti mahu membuang \"{name}\"?",
  delete_access_control_success: "Anda telah berjaya membuang \"{name}\".",
  add_access_control_confirm: "Adakah anda pasti mahu menambah kawalan akses?",
  add_access_control_success: "Anda telah berjaya menambah kawalan akses.",
  delete_access_auto_confirm: "Adakah anda pasti ingin mengalih keluar \"{name}\"?",
  delete_access_auto_success: "Anda telah berjaya mengalih keluar \"{name}\".",
  add_access_auto_confirm: "Adakah anda pasti ingin menambah ke dalam pelantikan automatik?",
  add_access_auto_success: "Anda telah berjaya menambah ke dalam pelantikan automatik.",
  move_banner_confirm: "Adakah anda pasti ingin menukar \"{name}\" ke jawatan \"{position}\"?",
  delete_game_exclude_confirm: "Adakah anda pasti ingin memadam \"{name}\"?",
  banner_size_tooltips: "Sila ikut dimensi saiz imej yang dibenarkan: \"{size}\".",
  purchase_domain_success: "Domain dibeli dengan jayanya!",
  purchase_domain_failed: "Domain dibeli gagal!",
  apply_domain_success: "Domain dipohon dengan jayanya!",
  apply_domain_failed: "Domain dipohon gagal!",
  tooltips_pnl: "Platform winlose x Platform PT % = Pendapatan Jumlah",
  delete_package_confirm: "Adakah anda pasti ingin memadam pakej \"{package}\"?",
  search_by_lang_code: "Cari mengikut Kod Bahasa",
  pleaseSelectAnImage: "Sila Pilih Imej",
  pleaseSelectAValidImageType: "Sila Pilih Jenis Imej yang Sah",
  imageTooLargeMaxSizeAllowedIsOneMb: "Imej terlalu besar, saiz maksimum dibenarkan adalah 1MB",
  uploadYourLogoWithPngOrJpegFormat: "Muat naik logo anda dalam format png atau jpeg",
  allowedPngAndJpegOnlyMaxOneMb: "Hanya png dan jpeg dibenarkan (Saiz imej maksimum 1MB)",
  delete_theme_content_confirm: "Adakah anda pasti mahu memadam kandungan tema \"{themecontent}\"?",
  delete_theme_confirm: "Adakah anda pasti mahu memadam tema \"{theme}\"?",
  delete_color_confirm: "Adakah anda pasti mahu memadam warna \"{color}\"?",
  delete_content_confirm: "Adakah anda pasti mahu memadam kandungan \"{content}\"?",
  reset_password_confirm: "Adakah anda pasti ingin menetapkan semula kata laluan untuk \"{userid}\"?",
  block_account_confirm: "Adakah anda pasti ingin menyekat \"{userid}\"?",
  suspend_account_confirm: "Adakah anda pasti ingin menggantung \"{userid}\"?",
  active_account_confirm: "Adakah anda pasti ingin mengaktifkan \"{userid}\"?",
  temporaryPasswordFor: "Kata laluan sementara untuk \"{name}\" adalah",
  needAiToGenerateLogo: "Perlu AI untuk menjana logo",
  delete_domain_confirm: "Adakah anda pasti mahu memadam domain \"{domain}\"?",
  previewImageForIllustrationOnly: "Imej pratonton yang ditunjukkan adalah untuk tujuan ilustrasi sahaja.",
  actualResultMayVary: "Hasil sebenar mungkin berbeza disebabkan peningkatan laman web.",
  chooseYourPreferedResponsiveLayoutTheme: "Pilih tema susun atur responsif pilihan anda",
  chooseYourPreferedColor: "Pilih warna pilihan anda",
  please_update_provider_before_edit_game: "Sila kemas kini penyedia sebelum mengedit permainan",
  delete_theme_content_group_confirm: "Adakah anda pasti mahu memadam kumpulan kandungan tema \"{themecontentgroup}\"?",
  phoneFormat: "cth. +63XXXXXXXXXX",
  change_theme_will_replace_menu: "Adakah anda pasti mahu mengemas kini tema? (Tukar tema akan menyebabkan Menu digantikan)",
  change_provider_seq_confirm: "Adakah anda pasti ingin menukar urutan \"{provider}\"?",
  change_provider_status_confirm: "Adakah anda pasti ingin menukar status penyedia \"{provider}\"?",
  actionPerformWillReflectProd: "* Sebarang tindakan yang dilakukan di sini akan terus mencerminkan kepada Produksi",
  site_sync_confirm: "Adakah anda pasti ingin menyegerakkan ke Pengeluaran?",
  clear_profile_setting_maintenance_confirm: "Adakah anda pasti ingin membersihkan penyelenggaraan?",
  change_social_platform_status_confirm: "Adakah anda pasti ingin menukar status platform sosial \"{name}\"?",
  search_by_site_name: "Cari Mengikut Nama Laman",
  change_social_account_status_confirm: "Adakah anda pasti ingin menukar status akaun sosial \"{name}\"?",
  themeMenuMessage1: "* Susun semula urutan menu dengan seret dan lepas item menu",
  themeMenuMessage2: "* Nyahcentang kotak semak jika ingin menyembunyikan item menu",
  search_by_operator: "Cari Mengikut Pengendali",
  search_by_ticket: "Cari Mengikut Tiket",
  search_member: "Cari Ahli",
  site_recreate_confirm: "Adakah anda pasti ingin mencipta semula laman \"{name}\"?",
  search_by_game_type: "Cari Mengikut Jenis Permainan",
  total_not_count_by_date_range: "Jumlah ini tidak dikira mengikut julat tarikh.",
  tooltips_upload_size: "Saiz fail yang dimuat naik tidak boleh melebihi 1MB.",
  tooltips_href: "Medan Href memerlukan sambungan domain. Contoh: 'yourwebsite.com/promotions', isikan 'promotions' sahaja.",
  d_winlose_chart: "Visualisasikan tren menang/kalah dan pengeluaran.",
  d_turnover_chart: "Menganalisis tren perolehan dan deposit.",
  d_deposit: "Menunjukkan jumlah deposit dan ahli unik.",
  d_withdrawal: "Memaparkan jumlah transaksi pengeluaran keseluruhan.",
  d_active_player: "Jumlah pertaruhan dan log masuk unik oleh pemain.",
  d_winlose: "Memaparkan jumlah bersih menang/kalah.",
  d_turnover: "Jumlah perolehan yang dihasilkan.",
  d_member: "Jumlah semua ahli berdaftar.",
  d_referee: "Jumlah rujukan pengguna.",
  d_verfied_signup: "Jumlah pengguna yang disahkan dan pendaftaran baru.",
  d_ftd: "Bilangan dan jumlah deposit pertama kali.",
  d_top_winner: "ID pemain dan jumlah kemenangan keseluruhan.",
  d_top_loser: "ID pemain dan jumlah kerugian keseluruhan.",
  d_top_deposit: "ID pemain dan jumlah deposit dari yang terbanyak ke yang terkurang.",
  d_top_withdrawal: "ID pemain dan jumlah pengeluaran dari yang terbanyak ke yang terkurang.",
  d_top_promotion: "Ranking, ID promosi, nama, dan tuntutan oleh pemain.",
  d_payment_gateway: "Ranking, kaedah, vendor, diproses, ditolak, jumlah, dan kadar kejayaan melalui pintu masuk.",
  tooltips_promo_member_custom: "Sila masukkan beberapa ID ahli dengan pemisah koma. Contoh: member001,member002,member003",
  tooltips_social_facebook: "Contoh: https://www.facebook.com/",
  tooltips_social_instagram: "Contoh: https://www.instagram.com/",
  tooltips_social_skype: "Contoh: skype:<username>?chat",
  tooltips_social_telegram: "Contoh: https://t.me/<ID>",
  tooltips_social_tiktok: "Contoh: https://www.tiktok.com/<ID>",
  tooltips_social_wechat: "Contoh: <ID>",
  tooltips_social_whatsapp: "Contoh: https://wa.me/<ID>",
  tooltips_social_youtube: "Contoh: https://www.youtube.com/<ID>",
  search_by_business_id: "Cari Mengikut ID Perniagaan",
  ticket_taken_confirm: "Adakah anda pasti ingin mengambil alih tiket id ini \"{name}\"?",
  tooltips_payment_setting: "Yang berikut hanya akan dipaparkan jika 'Tetapan' - 'Tetapan Pembayaran' ditetapkan kepada 'SENDIRI'",
  tooltips_cms_announcement_main: "Maksimum 5 banner pengumuman untuk pengalaman pengguna terbaik",
  tooltips_cms_announcement_title: "Maksimum 30 aksara untuk pengalaman pengguna terbaik",
  tooltips_cms_announcement_body: "Maksimum 200 aksara untuk pengalaman pengguna terbaik",
  delete_livechat_confirm: "Adakah anda pasti ingin memadamkan sembang langsung?",
  tooltips_vip_name: "Maksimum 10 aksara untuk pengalaman pengguna terbaik",

  choosePackage: "Pilih Pakej",
  effortlessCreate: "Cipta, optimumkan, dan urus laman web anda dengan mudah!",
  raiseNewHeight: "Membawa anda ke tahap yang lebih tinggi",
  fastSecureStable: "Pantas, Selamat, dan Stabil",
  realTimeData: "Wawasan Data Masa Nyata",
  highLevelTechTeam: "Pasukan Teknologi Bertaraf Tinggi!",
  strategicEmpowerment: "Pemberdayaan Strategik!",
  supportFirst: "Sokongan 24/7 mengutamakan anda dengan penyelesaian yang diperibadikan!",
  empowermentBusiness: "Pemberdayaan melalui pakej Eksekutif untuk mencapai matlamat perniagaan!",
  pleaseFillUpSiteDetails: "Sila isi butiran laman web anda",
  reviewYourOptionsAndCheckout: "Semak pilihan anda dan teruskan ke pembayaran",
  chooseYourPreferedResponsiveLayoutTheme: "Pilih tema susun atur responsif yang anda suka",
  chooseYourPreferedColor: "Pilih warna yang anda suka",
  pleaseSelectTheme: "Sila Pilih Tema",
  pleaseSelectColor: "Sila Pilih Warna",
  websiteLayoutAndThemeDesign: "Reka Bentuk Susun Atur & Tema Laman Web",
  operatorAccCreatedSuccessful: "Akaun Operator Berjaya Dicipta",
  delete_default_template_confirm: "Adakah anda pasti mahu memadam templat permainan mini \"{template}\"?",
  search_by_template_code: "Cari berdasarkan Kod Templat",
  delete_mini_game_confirm: "Adakah anda pasti mahu memadam permainan mini \"{minigame}\"?",
  delete_mini_game_template_confirm: "Adakah anda pasti mahu memadam templat permainan mini \"{minigametemplate}\"?",
  delete_reward_confirm: "Adakah anda pasti mahu memadam ganjaran \"{reward}\"?",
  search_by_game_name: "Cari berdasarkan Nama Permainan",
  tooltips_gamereward: "Had: {max}",
  change_gamify_status_confirm: "Adakah anda pasti mahu menukar status ganjaran \"{gamify}\"?",
  change_gamify_login_status_confirm: "Adakah anda pasti mahu menukar status log masuk ganjaran \"{gamify}\"?",
  change_gamify_daily_login_status_confirm: "Adakah anda pasti mahu menukar status ganjaran Daftar Masuk Harian (Check-in Harian)?",
  change_partner_seq_confirm: "Adakah anda pasti ingin menukar urutan \"{id}\"?",
  tooltips_partners_link: "Contoh: https://www.google.com/",
  delete_partner_confirm: "Adakah anda pasti mahu memadam rakan kongsi \"{name}\"?"
};
